import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { subscribeMedia, subscribeNotes, subscribeGuestPhotos } from "../lib/firebase";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function LiveNotifications() {
  const { role } = useAuth();
  const location = useLocation();
  const seenIds = useRef(new Set());
  const initialized = useRef(false);

  useEffect(() => {
    // Don't show notifications on login or story page
    if (!role || location.pathname === "/login" || location.pathname === "/our-story") return;

    // Seed existing IDs on first load so we don't spam on mount
    let seeded = false;

    const unsub1 = subscribeMedia((items) => {
      if (!seeded) { items.forEach((i) => seenIds.current.add(i.id)); return; }
      items.forEach((item) => {
        if (!seenIds.current.has(item.id)) {
          seenIds.current.add(item.id);
          const who = item.guestName || "Someone";
          const what = item.kind === "video" ? "uploaded a video 🎬" : item.kind === "selfie" ? "took a selfie 📸" : "shared a photo 📷";
          toast(`${who} just ${what}`, { duration: 4000 });
        }
      });
    });

    const unsub2 = subscribeNotes((items) => {
      if (!seeded) { items.forEach((i) => seenIds.current.add(i.id)); return; }
      items.forEach((item) => {
        if (!seenIds.current.has(item.id)) {
          seenIds.current.add(item.id);
          const who = item.guestName || "Someone";
          toast(`${who} left a message in the guest book 💬`, { duration: 4000 });
        }
      });
    });

    const unsub3 = subscribeGuestPhotos((items) => {
      if (!seeded) { items.forEach((i) => seenIds.current.add(i.id)); return; }
      items.forEach((item) => {
        if (!seenIds.current.has(item.id)) {
          seenIds.current.add(item.id);
          toast(`📸 ${item.guestName} has been added to Guest Photos!`, { duration: 5000 });
        }
      });
    });

    // After a short delay, mark as seeded so future additions trigger toasts
    const timer = setTimeout(() => { seeded = true; }, 2500);

    return () => {
      unsub1 && unsub1();
      unsub2 && unsub2();
      unsub3 && unsub3();
      clearTimeout(timer);
    };
  }, [role, location.pathname]);

  return null;
}
